 "use strict";
 /**
  * trsHight Module
  *
  * Description
  */
 angular.module('trsScrollbarModule', []).directive('trsScrollbar', ['$window', '$parse', '$timeout', function ($window, $parse, $timeout) {

     return {
         restrict: 'EA',
         link: function (scope, iElement, iAttrs) {
             fixScrollbarHeight();

             function fixScrollbarHeight() {
                 var $contentTextWrap = $(".content_text_wrap");
                 var $contentTextForm = $contentTextWrap.find('.content_text_form');
                 var $footerText = $contentTextWrap.find('.foot_text');
                 var $trsScrollbar = $(".trsScrollbar");
                 $contentTextWrap.scroll(function () {
                     $trsScrollbar.height(0);
                     //判断是否触发底部
                     if ($contentTextWrap.scrollTop() >= $contentTextForm.height() - $contentTextWrap.height() - $footerText.height()) {
                         //计算挡板高度
                         var fixHeight = $contentTextWrap.scrollTop() - ($contentTextForm.height() - $contentTextWrap.height() - $footerText.height() + 15);
                         $trsScrollbar.height(fixHeight);
                     }
                 });
             }
         }
     };
 }]);